import { call, put, takeEvery, all } from "redux-saga/effects";
import * as types from "./types";

import { apiSuccess, apiFailure } from "./actions";
import {
  completeReminderService,
  createReminderService,
  deleteReminderService,
  exportRemindersService,
  fetchReminderByIdService,
  fetchReminderCalendarService,
  fetchRemindersQueueService,
  fetchRemindersService,
  getReminderActivityLogs,
  snoozeReminderService,
  updateReminderService,
} from "src/services/reminder.services";

// ==============================
// Worker Sagas (perform API calls)
// ==============================

function* handleCreateReminder(action: any): any {
  try {
    const response = yield call(createReminderService, action.payload);
    yield put(apiSuccess(types.CREATE_REMINDER, response));
  } catch (error: any) {
    yield put(apiFailure(types.CREATE_REMINDER, error.message));
  }
}

function* handleFetchReminders(): any {
  try {
    console.log("🔁 Fetching reminders in saga...");
    const response = yield call(fetchRemindersService);
    yield put(apiSuccess(types.FETCH_REMINDERS, response));
  } catch (error: any) {
    yield put(apiFailure(types.FETCH_REMINDERS, error.message));
  }
}

function* handleFetchReminderById(action: any): any {
  try {
    const response = yield call(fetchReminderByIdService, action.id);
    yield put(apiSuccess(types.FETCH_REMINDER_BY_ID, response));
  } catch (error: any) {
    yield put(apiFailure(types.FETCH_REMINDER_BY_ID, error.message));
  }
}

function* handleUpdateReminder(action: any): any {
  try {
    const response = yield call(
      updateReminderService,
      action.id,
      action.payload
    );
    yield put(apiSuccess(types.UPDATE_REMINDER, response));
  } catch (error: any) {
    yield put(apiFailure(types.UPDATE_REMINDER, error.message));
  }
}

function* handleDeleteReminder(action: any): any {
  try {
    const response = yield call(deleteReminderService, action.id);
    yield put(apiSuccess(types.DELETE_REMINDER, response));
  } catch (error: any) {
    yield put(apiFailure(types.DELETE_REMINDER, error.message));
  }
}

function* handleCompleteReminder(action: any): any {
  try {
    const response = yield call(completeReminderService, action.payload);
    yield put(apiSuccess(types.COMPLETE_REMINDER, response));
  } catch (error: any) {
    yield put(apiFailure(types.COMPLETE_REMINDER, error.message));
  }
}

function* handleSnoozeReminder(action: any): any {
  try {
    const response = yield call(snoozeReminderService, action.payload);
    yield put(apiSuccess(types.SNOOZE_REMINDER, response));
  } catch (error: any) {
    yield put(apiFailure(types.SNOOZE_REMINDER, error.message));
  }
}

function* handleFetchReminderCalendar(action: any): any {
  try {
    console.log(
      "🎯 Saga: handleFetchReminderCalendar called with payload:",
      action.payload
    );
    const {
      startDate,
      endDate,
      searchTerm,
      reminderType,
      status,
      userId,
      sortBy,
      sortOrder,
    } = action.payload || {};

    const response = yield call(
      fetchReminderCalendarService,
      startDate,
      endDate,
      searchTerm,
      reminderType,
      status,
      userId,
      sortBy,
      sortOrder
    );

    console.log(
      "📥 Saga: Got response from fetchReminderCalendarService:",
      response
    );
    yield put(apiSuccess(types.FETCH_REMINDER_CALENDAR, response));
  } catch (error: any) {
    console.error("❌ Saga: Error in handleFetchReminderCalendar:", error);
    yield put(apiFailure(types.FETCH_REMINDER_CALENDAR, error.message));
  }
}

function* handleFetchReminderQueue(action: any): any {
  try {
    const response = yield call(fetchRemindersQueueService, action.payload);
    yield put(apiSuccess(types.FETCH_REMINDER_QUEUE, response));
  } catch (error: any) {
    yield put(apiFailure(types.FETCH_REMINDER_QUEUE, error.message));
  }
}

function* handleFetchReminderLogs(action: any): any {
  try {
    const response = yield call(getReminderActivityLogs, action.id);
    yield put(apiSuccess(types.FETCH_REMINDER_LOGS, response));
  } catch (error: any) {
    yield put(apiFailure(types.FETCH_REMINDER_LOGS, error.message));
  }
}

function* handleExportReminders(action: any): any {
  try {
    const response = yield call(exportRemindersService, action.payload);
    yield put(apiSuccess(types.EXPORT_REMINDERS, response));
  } catch (error: any) {
    yield put(apiFailure(types.EXPORT_REMINDERS, error.message));
  }
}

// ==============================
// Watcher Saga
// ==============================

export default function* reminderSaga() {
  yield all([
    takeEvery(types.CREATE_REMINDER, handleCreateReminder),
    takeEvery(types.FETCH_REMINDERS, handleFetchReminders),
    takeEvery(types.FETCH_REMINDER_BY_ID, handleFetchReminderById),
    takeEvery(types.UPDATE_REMINDER, handleUpdateReminder),
    takeEvery(types.DELETE_REMINDER, handleDeleteReminder),
    takeEvery(types.COMPLETE_REMINDER, handleCompleteReminder),
    takeEvery(types.SNOOZE_REMINDER, handleSnoozeReminder),
    takeEvery(types.FETCH_REMINDER_CALENDAR, handleFetchReminderCalendar),
    takeEvery(types.FETCH_REMINDER_QUEUE, handleFetchReminderQueue),
    takeEvery(types.FETCH_REMINDER_LOGS, handleFetchReminderLogs),
    takeEvery(types.EXPORT_REMINDERS, handleExportReminders),
  ]);
}
